import algoliasearch from "algoliasearch";
import { Swiper, Navigation, Mousewheel } from "swiper";

import ArticleCardRenderer from "../common/article-card-renderer";
const articleCardRenderer = ArticleCardRenderer();

import ModalArticle from "../sections/modal-2023-article";
const modalArticle = ModalArticle();

const renderLatestArticles = (section) => {
  const client = algoliasearch("ZGISPFZEQK", "ebbe04351ebe8091e1d417fe4ed7d8b3");
  const entriesIndex = client.initIndex("entries_store_date");
  entriesIndex
    .search("", {
      hitsPerPage: 16,
      page: 0,
      filters: "",
      numericFilters: [],
      facetFilters: ["tags:F/STORE"], // [`categories:お買いモノ`, `hasStoreProduct:true`]
    })
    .then((result) => {
      renderArticlesInner(section, result.hits, false);
    });
};

const renderSelectedArticles = (section) => {
  const client = algoliasearch("ZGISPFZEQK", "ebbe04351ebe8091e1d417fe4ed7d8b3");
  const entriesIndex = client.initIndex("entries");
  entriesIndex.getObjects(section.articleIds).then((result) => {
    renderArticlesInner(section, result.results, false);
  });
};

const renderBrandArticles = (section) => {
  const client = algoliasearch("ZGISPFZEQK", "ebbe04351ebe8091e1d417fe4ed7d8b3");
  const entriesIndex = client.initIndex("entries_store_date");

  let collectionTitle = section.collectionTitle;
  if (collectionTitle == "JOHN MASON SMITH / JANE SMITH") {
    entriesIndex
      .search("", {
        hitsPerPage: 16,
        page: 0,
        filters: `(blog.id:3 OR blog.id:16 OR blog.id:32) AND (brands.name:'JOHN MASON SMITH' OR brands.name:'JANE SMITH')`,
      })
      .then((result) => {
        renderArticlesInner(section, result.hits, true);
      });
    return;
  }

  if (collectionTitle == "TARO HORIUCHI / th products") {
    collectionTitle = "th products";
  } else if (collectionTitle == "kotohayokozawa") {
    collectionTitle = "Kotoha Yokozawa";
  }
  entriesIndex
    .search("", {
      hitsPerPage: 16,
      page: 0,
      filters: `(blog.id:3 OR blog.id:16 OR blog.id:32) AND brands.name:'${collectionTitle.replace("'", "\\'")}'`,
    })
    .then((result) => {
      renderArticlesInner(section, result.hits, true);
    });
};

const renderArticlesInner = (section, articles, isBrand) => {
  if (articles.length <= 0) {
    const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
    sectionElement.style.display = "none";
    return;
  }
  if (!window.fstore.mediaCache) {
    window.fstore.mediaCache = {};
  }
  if (!window.fstore.mediaCache.articles) {
    window.fstore.mediaCache.articles = [];
  }
  window.fstore.mediaCache.articles = window.fstore.mediaCache.articles.concat(articles);

  let aspectRatio = 100;
  articles.forEach((article) => {
    aspectRatio = Math.min(aspectRatio, article.thumbnail.width / article.thumbnail.height);
  });
  const items = articles.map((article) => {
    const item = articleCardRenderer.renderArticle(article, aspectRatio);
    return `<div class="swiper-slide">${item}</div>`;
  });

  const sectionElement = document.querySelector(`#shopify-section-${section.id}`);
  const swiperElement = sectionElement.querySelector(".swiper");
  const wrapperElement = swiperElement.querySelector(".swiper-wrapper");
  wrapperElement.innerHTML = items.join("");

  wrapperElement.querySelectorAll(".fs-article-card a").forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      modalArticle.showModalArticle(a.dataset["articleId"]);
    });
  });

  section.swiper = new Swiper(swiperElement, {
    modules: [Navigation, Mousewheel],
    centerInsufficientSlides: true,
    speed: 300,
    slidesPerView: 2.5,
    slidesPerGroup: 1,
    spaceBetween: 8,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
      sensitivity: 0.1,
      thresholdDelta: 10,
    },
    navigation: {
      nextEl: sectionElement.querySelector(".fs-swiper-navigation-next"),
      prevEl: sectionElement.querySelector(".fs-swiper-navigation-prev"),
    },
    breakpoints: {
      992: {
        speed: 900,
        slidesPerView: 6.4,
        slidesPerGroup: 6,
        spaceBetween: 8,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      },
      1298: {
        speed: 900,
        slidesPerView: isBrand ? 7.5 : 5.2,
        slidesPerGroup: isBrand ? 7 : 5,
        spaceBetween: 12,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      },
    },
  });
};

const mediaSliderArticlesMain = () => {
  if (!window.fstore.sections) {
    return;
  }
  window.fstore.sections.forEach((section) => {
    if (section.sectionType == "media-slider-articles-latest") {
      renderLatestArticles(section);
    } else if (section.sectionType == "media-slider-articles-selected") {
      renderSelectedArticles(section);
    } else if (section.sectionType == "media-slider-articles-brand") {
      renderBrandArticles(section);
    }
  });
};

addEventListener("DOMContentLoaded", (event) => {
  mediaSliderArticlesMain();
});
